import { useState, useEffect } from "react";


const useGridSize = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1000)
  const [gridSize, setGridSize] = useState((!isMobile) ? window.innerWidth / 8.2 : window.innerHeight / 4.8);

  useEffect(() => {
    let gridWidth = Math.round(window.innerWidth / gridSize);
    let gridEdgeDecrease = Math.floor(window.innerWidth / gridSize) * gridSize + 20;
    let gridEdgeIncrease = Math.ceil(window.innerWidth / gridSize) * gridSize + 20;

    const handleResize = (e) => {
      if (window.innerWidth < 1000) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }
      if (!isMobile) {
        // setGridSize(window.innerWidth / 8.2);
        if ((window.innerWidth - gridEdgeDecrease) < -10) {
          setGridSize(((gridWidth - 0.8) * gridSize) / gridWidth);
        }
        if ((window.innerWidth - gridEdgeIncrease) > 10) {
          setGridSize(((gridWidth + 1) * gridSize) / gridWidth);
        }
      } else {
        // setGridSize(window.innerHeight / 4.8);
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [gridSize, isMobile])

  return gridSize;
}

export default useGridSize;